import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import { DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUPS } from 'common/dataTableConstants';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_LISTINGS_SCRAPER_LOG_GROUPS } from 'client/constants/screenIds';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrTable, { SR_TABLE_THEME_PARTNER_CLEAR } from 'client/components/SrTable';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';

const SrUtilityProfitListingsScraperLogsTable = ({ logGroupId }) => {
  const [viewingLogGroup, setViewingLogGroup] = useState(null);

  return (
    <div>
      <SrDataTableConnected
        itemsPropName="logGroups"
        rootViewId={DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUPS}
        dataSource={DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUPS}
        initialViewSettings={{
          sort: {
            createdAt: 'desc',
          },
          filter: logGroupId ? { listingScraperLogGroupId: logGroupId } : null,
          loadAllData: !!logGroupId,
        }}
        count={logGroupId ? undefined : 100}
      >
        {({ logGroups, onInfiniteScrollWrapperRef }) => (
          <div ref={onInfiniteScrollWrapperRef}>
            <SrTable
              theme={SR_TABLE_THEME_PARTNER_CLEAR}
              headers={[
                { content: 'Created' },
                { content: 'Log Group ID' },
                { content: 'Partner' },
                { content: 'Status' },
                { content: 'Listings' },
                { content: 'URL' },
              ]}
              rows={logGroups.map((logGroup) => ({
                onClick: () => setViewingLogGroup(logGroup),
                cells: [
                  {
                    content: momentWithAustinTimezone(logGroups.createdAt).format(
                      'MM/DD/YYYY h:mm A',
                    ),
                  },
                  { content: logGroup.id },
                  { content: logGroup.utilityPartnerName },
                  { content: logGroup.status },
                  { content: logGroup.addressCount },
                  { content: logGroup.urls.join('\n') },
                ],
              }))}
            />
          </div>
        )}
      </SrDataTableConnected>
      {viewingLogGroup && (
        <SrDarkModal onClose={() => setViewingLogGroup(null)}>
          <SrModalContent
            onCloseIconClick={() => setViewingLogGroup(null)}
            style={{ width: 1040, height: '94vh' }}
          >
            <pre>{JSON.stringify(viewingLogGroup, null, 2)}</pre>
          </SrModalContent>
        </SrDarkModal>
      )}
    </div>
  );
};

SrUtilityProfitListingsScraperLogsTable.propTypes = {
  logGroupId: PropTypes.number,
};

SrUtilityProfitListingsScraperLogsTable.displayName = 'SrUtilityProfitListingsScraperLogsTable';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_LISTINGS_SCRAPER_LOG_GROUPS)
@withScrollToTop
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
class UtilityProfitAdminListingsScraperLogGroupsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Listings Scraper Log Groups | Utility Profit',
  });

  render() {
    const { location } = this.props;

    const { logGroupId: logGroupIdStr } = queryString.parse(location.search);

    const logGroupId = parseInt(logGroupIdStr, 10);

    return (
      <SrPartnerPageV2
        navbarTitle="Utility Profit Admin"
        navbarImage="/images/utility-profit-logo.svg"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="100%"
      >
        <SrBox paddingBottom="20px">
          <SrText weight="800" display="block" size="26" lineHeight="33px" font="greycliff">
            Listings Scraper Logs
          </SrText>
        </SrBox>
        <SrUtilityProfitListingsScraperLogsTable logGroupId={logGroupId} />
      </SrPartnerPageV2>
    );
  }
}

UtilityProfitAdminListingsScraperLogGroupsPage.displayName =
  'UtilityProfitAdminListingsScraperLogGroupsPage';

export default UtilityProfitAdminListingsScraperLogGroupsPage;
